import React from 'react';
import { Link } from 'react-router-dom';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import { AppAlert, AppButton } from '../../components/ui';
import { ROUTES } from '../../config/routes';
import useKlubMagazine from '../../hooks/useKlubMagazine';
import KlubMagazinePanel from '../../components/klub/magazine/KlubMagazinePanel';
import KlubMagazineCommercantEditModal from '../../components/klub/magazine/KlubMagazineCommercantEditModal';
import KlubMagazineOffreEditModal from '../../components/klub/magazine/KlubMagazineOffreEditModal';
import KlubMagazineSetEditModal from '../../components/klub/magazine/KlubMagazineSetEditModal';
import KlubMagazinePickerModal from '../../components/klub/magazine/KlubMagazinePickerModal';
import KlubMagazineSetPickerModal from '../../components/klub/magazine/KlubMagazineSetPickerModal';
import { SET_RESUME_MAX_LENGTH } from '../../components/klub/magazine/magazineHelpers';
import '../../styles/klub-magazine.scss';
import '../../styles/kkp-planning-view-mode.scss';
import '../../styles/kkp-planning-page.scss';

const KlubMagazinePage = () => {
  const mag = useKlubMagazine();

  return (
    <MasterLayout>
      <Breadcrumb
        title="Export magazine"
        actions={(
          <AppButton
            as={Link}
            to={ROUTES.klub.dashboard}
            size="sm"
            variant="outline-secondary"
            icon="mdi:arrow-left"
          >
            Retour
          </AppButton>
        )}
      />
      {mag.modal}

      {mag.error ? <AppAlert variant="danger" className="mb-3">{mag.error}</AppAlert> : null}

      <KlubMagazinePanel
        tab={mag.tab}
        setTab={mag.setTab}
        month={mag.month}
        setMonth={mag.setMonth}
        monthOptions={mag.monthOptions}
        busy={mag.busy}
        loading={mag.loading}
        editable={mag.editable}
        sensors={mag.sensors}
        commercants={mag.commercants}
        offres={mag.offres}
        dates={mag.dates}
        setDates={mag.setDates}
        agendaDates={mag.agendaDates}
        isDatesTab={mag.isDatesTab}
        targetCount={mag.targetCount}
        setTargetCount={mag.setTargetCount}
        targetLabel={mag.targetLabel}
        targetInputId={mag.targetInputId}
        targetMax={mag.targetMax}
        exportDisabled={mag.exportDisabled}
        resolveCommercantStatut={mag.resolveCommercantStatut}
        resolveOffreStatut={mag.resolveOffreStatut}
        onPropose={mag.handlePropose}
        onOpenPicker={mag.openPicker}
        onExport={mag.handleExport}
        onRewrite={() => mag.handleRewrite()}
        onClearSelection={mag.handleClearSelection}
        onDragEndCommercants={mag.onDragEndCommercants}
        onDragEndOffres={mag.onDragEndOffres}
        onDragEndDates={mag.onDragEndDates}
        onEditCommercant={mag.openEditCommercant}
        onEditOffre={mag.openEditOffre}
        onEditDate={mag.openEditDate}
        onRewriteDate={(row) => mag.handleRewrite([row.id])}
        onRemoveCommercant={mag.removeCommercant}
        onRemoveOffre={mag.removeOffre}
        onRemoveDate={mag.removeDate}
        onInlineSave={mag.saveInlineField}
        onToggleNouveau={mag.toggleNouveau}
      />

      <KlubMagazineCommercantEditModal
        show={Boolean(mag.editCommercant)}
        busy={mag.busy}
        form={mag.commercantForm}
        onChangeForm={mag.setCommercantForm}
        onClose={mag.closeEditCommercant}
        onSave={mag.saveCommercant}
      />

      <KlubMagazineOffreEditModal
        show={Boolean(mag.editOffre)}
        busy={mag.busy}
        form={mag.offreForm}
        onChangeForm={mag.setOffreForm}
        onClose={mag.closeEditOffre}
        onSave={mag.saveOffre}
      />

      <KlubMagazineSetEditModal
        show={Boolean(mag.editDate)}
        busy={mag.busy}
        form={mag.dateForm}
        date={mag.editDate}
        resumeMax={mag.tab === 'set' ? SET_RESUME_MAX_LENGTH : null}
        onChangeForm={mag.setDateForm}
        onClose={mag.closeEditDate}
        onSave={mag.saveDate}
        onRewrite={() => mag.editDate && mag.handleRewrite([mag.editDate.id])}
      />

      {mag.pickerKind === 'set' || mag.pickerKind === 'agenda' ? (
        <KlubMagazineSetPickerModal
          show={mag.pickerOpen}
          busy={mag.busy}
          candidateSearch={mag.candidateSearch}
          thematiqueId={mag.pickerThematiqueId}
          dateFrom={mag.pickerDateFrom}
          dateTo={mag.pickerDateTo}
          thematiques={mag.thematiques}
          selectedCandidateIds={mag.selectedCandidateIds}
          filteredCandidates={mag.filteredSetCandidates}
          onClose={mag.closePicker}
          onChangeSearch={mag.setCandidateSearch}
          onChangeThematique={mag.setPickerThematiqueId}
          onChangeDateFrom={mag.setPickerDateFrom}
          onChangeDateTo={mag.setPickerDateTo}
          onToggleCandidate={mag.toggleCandidate}
          onAddSelected={mag.addSelectedCandidates}
        />
      ) : (
        <KlubMagazinePickerModal
          show={mag.pickerOpen}
          busy={mag.busy}
          pickerKind={mag.pickerKind}
          candidateSearch={mag.candidateSearch}
          candidateBucket={mag.candidateBucket}
          selectedCandidateIds={mag.selectedCandidateIds}
          activeCandidateSource={mag.activeCandidateSource}
          flatCandidates={mag.flatCandidates}
          filteredCandidates={mag.filteredCandidates}
          commercants={mag.commercants}
          offres={mag.offres}
          onClose={mag.closePicker}
          onChangeSearch={mag.setCandidateSearch}
          onChangeBucket={mag.setCandidateBucket}
          onToggleCandidate={mag.toggleCandidate}
          onAddSelected={mag.addSelectedCandidates}
        />
      )}
    </MasterLayout>
  );
};

export default KlubMagazinePage;
